import { Button } from '@bambi/component-library/src/components/Button/Button';
import { useCallback } from 'react';

import { adminActions } from '../admin.slice';
import { useAppDispatch } from 'src/app/store/hooks';

export function ModivcareSettingsRouteActions() {
  const dispatch = useAppDispatch();

  const handleAddModivcareSettings = useCallback(() => {
    dispatch(adminActions.setShowModivcareSettingsModal(true));
  }, [dispatch]);

  return (
    <div className="flex flex-row gap-2">
      <Button onClick={handleAddModivcareSettings} variant="primary">
        Add Modivcare Settings
      </Button>
    </div>
  );
}
